import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoalEmail from './icon-goal-email.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoalEmail {...validProps} />;
}
SvgComponent.iconName = 'goal-email';

/**
 * @deprecated This is a legacy icon
 */
export const GoalEmailIcon = svgIconWrapper(SvgComponent);
